import AccessibilityUtilities from "./utilities/accessibility.js";
import urlParameterTrackingInit from "./utilities/url-parameter-tracking.ts";
import cardsInit from "./components/card.ts";
import newsFeedInit from "./components/news-feed.ts";
import accordionInit from "./components/accordion.ts";
import carouselInit from "./components/carousel.ts";
import siteHeaderInit from "./components/site-header.ts";
import videoEmbedInit from "./components/video-embed.ts";
import modalInit from "./components/modal.ts";
import subnavInit from "./components/subnav.ts";
import cookieBarInit from "./components/cookies.ts";
import alertsInit from "./components/emergency-alert.ts";
import tabsInit from "./components/tabs.ts";
import homeHeroInit from "./components/home-hero.ts";
import homeInit from "./pages/home.ts";
import landingPageHeroInit from "./components/landing-page-hero.ts";
import timelineInit from "./components/timeline.ts";

// Import the main CSS file for the application (keep this line here after other imports)
import "../css/index.css";

document.addEventListener("DOMContentLoaded", () => {
  AccessibilityUtilities.init();
  urlParameterTrackingInit();
  cardsInit();
  newsFeedInit();
  accordionInit();
  carouselInit();
  modalInit();
  subnavInit();
  videoEmbedInit();
  siteHeaderInit();
  cookieBarInit();
  alertsInit();
  tabsInit();
  homeHeroInit();
  homeInit();
  landingPageHeroInit();
  timelineInit();
});
